import { SearchServiceTreatment } from "app/common/Model/SearchObject";
import {
  exportReportTreamentItem,
  sriTreatmentReport,
} from "app/services/ServiceRequestItemService";
import i18n from "i18n";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

toast.configure({
  autoClose: 2000,
  draggable: false,
  limit: 3,
});

export default class TreatmentReportStore {
  intactSearchObject = {
    ...new SearchServiceTreatment(),
    itemStatus: null, // Trạng thái yêu cầu,
    pageIndex: 1,
    pageSize: 10,

    orderDateFrom: new Date(new Date().setHours(0, 0, 0, 0)), // Thời gian chỉ định từ
    orderDateTo: (() => new Date(new Date().setHours(23, 59, 59, 999)))(), // Thời gian chỉ định đến
    getStaffRevenues: true,
    assigner: null,
    performDateFrom: null, // Thời gian thực hiện từ
    performDateTo: null, // Thời gian thực hiện đến
    roomId: null, // Phòng thực hiện
    healthCareSvId: null, //id cua dich vu
    performerId: null, // người thực hiện
    orderByDateFrom: true,
    currentTelesaleIds: [],
    patientSourceIds: [],
    currentPatientSourceIds: [],
  };

  searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
  totalElements = 0;
  totalPages = 0;
  listTreatmentReport = [];
  selectedTreatment = null;
  listChosen = [];
  constructor() {
    makeAutoObservable(this);
  }

  handleFilter = async (values) => {
    const newSearchObject = {
      ...this.searchObject,
      ...values,
      pageIndex: 1,
    };

    this.handleSetSearchObject(newSearchObject);
    this.handlecSriTreatmentReport();
  };

  handlePopupWith = () => {
    this.openPopupWith = true;
  };

  handleCloseConfirmReceiveTreatment = () => {
    this.openConfirmReceiveTreatmentPopup = false;
  };

  resetStore = () => {
    this.searchObject = JSON.parse(JSON.stringify(this.intactSearchObject));
    this.totalElements = 0;
    this.totalPages = 0;
    this.listTreatmentReport = [];
    this.selectedTreatment = null;
    this.listChosen = [];
  };

  handleSetSearchObject = (searchObject) => {
    if (searchObject.healthCareSv == null) {
      searchObject.healthCareSvId = null;
    } else {
      searchObject.healthCareSvId = searchObject?.healthCareSv?.id;
    }

    if (searchObject.assigner == null) {
      searchObject.assignerId = null;
    } else {
      searchObject.assignerId = searchObject?.assigner?.id;
    }

    if (searchObject.assigner == null) {
      searchObject.assignerId = null;
    } else {
      searchObject.assignerId = searchObject?.assigner?.id;
    }

    if (searchObject.room == null) {
      searchObject.roomId = null;
    } else {
      searchObject.roomId = searchObject?.room?.id;
    }
    this.searchObject = { ...searchObject };
  };

  handlecSriTreatmentReport = async () => {
    const {
      listDepId,
      performer,
      currentTelesaleIds,
      currentPatientSourceIds,
      patientSourceIds,
      ...ortherData
    } = this.searchObject;
    
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!listDepId || listDepId.length === 0) {
      this.listTreatmentReport = [];
      this.totalElements = 0;
      this.totalPages = 0;
      return;
    }
    
    if (performer) {
      ortherData.performerId = performer?.id;
    } else {
      ortherData.performerId = null;
    }
    if (listDepId) {
      ortherData.listDepId = listDepId?.map((el) => el?.id);
    } else {
      ortherData.listDepId = null;
    }

    if (currentTelesaleIds) {
      ortherData.currentTelesaleIds = currentTelesaleIds?.map((el) => el?.id);
    } else {
      ortherData.currentTelesaleIds = null;
    }

    if (patientSourceIds?.length > 0) {
      ortherData.patientSourceIds = patientSourceIds?.map((el) => el?.id);
    }
    if (currentPatientSourceIds?.length > 0) {
      ortherData.currentPatientSourceIds = currentPatientSourceIds?.map(
        (el) => el?.id
      );
    }
    try {
      const payload = {
        ...ortherData,
        getStaffRevenues: true,
      };
      const data = await sriTreatmentReport(payload);

      this.listTreatmentReport = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
    } catch (error) {
      console.error(error);
      toast.error(i18n.t("toast.error"));
    }
  };

  setPageIndex = async (page) => {
    this.searchObject.pageIndex = page;

    await this.handlecSriTreatmentReport();
  };

  setPageSize = async (pageSize) => {
    this.searchObject.pageSize = pageSize;
    this.searchObject.pageIndex = 1;

    await this.handlecSriTreatmentReport();
  };

  handleChangePage = async (newPage) => {
    await this.setPageIndex(newPage);
  };

  handleSelectListDelete = (deleteItems) => {
    this.listChosen = deleteItems;
  };

  handleClose = () => {
    this.listChosen = [];
  };

  getSelectedIds = () => {
    const ids = [];

    this?.listChosen?.forEach(function (item) {
      ids.push(item?.id);
    });

    return ids;
  };

  handleExportRegisterTreament = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = this.normalizeSearchReportTreament(searchObj);
    try {
      const response = await exportReportTreamentItem(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_DIEU_TRI.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportTreament = (rawSearch = {}) => {
    const {
      //department,
      listDepId,
      room,
      performer,
      assigner,
      healthCareSv,
      serviceGroup,
      treatmentPlanCard,
      patient,
      patientSourceIds,
      currentPatientSourceIds,
      ...rest
    } = rawSearch;

    return {
      ...rest,
      //departmentId: department?.id || rawSearch?.department || null,
      listDepId: listDepId?.map((el) => el?.id) || null,
      patientSourceIds: patientSourceIds?.map((el) => el?.id) || null,
      currentPatientSourceIds:
        currentPatientSourceIds?.map((el) => el?.id) || null,
      roomId: room?.id || rawSearch?.roomId || null,
      performerId: performer?.id || rawSearch?.performerId || null,
      assignerId: assigner?.id || rawSearch?.assignerId || null,
      healthCareSvId: healthCareSv?.id || rawSearch?.healthCareSvId || null,
    };
  };
}
